<template>
  <div class="py-6">
    <div class="relative max-w-7xl px-4 sm:px-6 md:px-8">
      <ListHeader :title="t('menu.importers')" :enableSearch="false" />

      <ErrorMessage v-if="importerStore.error" :error="importerStore.error" />

      <TabNavigation
        storeName="company.importer"
        :tabs="tabs"
        class="-mt-4 mb-8"
      />

      <ImporterConfigurations v-if="activeTab === 'importer-configurations'" />
      <AllImporterEvents v-else-if="activeTab === 'importer-events'" />
    </div>
  </div>
</template>

<script setup>
import ErrorMessage from '../components/ErrorMessage.vue'
import ListHeader from '../components/ListHeader.vue'
import { useI18n } from 'vue-i18n'
import { useImporterStore } from '../store/importerStore'
import { computed } from 'vue'
import TabNavigation from '../components/TabNavigation.vue'
import { useRoute } from 'vue-router'
import AllImporterEvents from './AllImporterEvents.vue'
import ImporterConfigurations from './ImporterConfigurations.vue'

const importerStore = useImporterStore()
const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global',
})
importerStore.loadConfig()

const route = useRoute()
const tabs = ['importer-configurations', 'importer-events']
const activeTab = computed(() => {
  return route.name
})
</script>
